import request from "@/utils/request";

/* 企业后台 -> 授权记录 */

/* 授权记录列表 */
export function getMandateRecord(query) {
  return request({
    url: '?m=Company&a=downloadHistory',
    method: 'get',
    params: query
  })
}

/* 主体下拉列表(简版) */
export function getMainList(query) {
  return request({
    url: '?m=Company&a=mainPart',
    method: 'get',
    params: query
  })
}

/* 下载账号/成员 下拉列表( 简单版 ) */
export function getMembersList(query) {
  return request({
    url: '?m=Company&a=members',
    method: 'get',
    params: query
  })
}
